import { DDDNormalResultPresentation } from "../normal/DDDNormalResultPresentation";

export class DDDFreespinResultPresentation extends DDDNormalResultPresentation {
    constructor(id: string = `DDDFreespinResultPresentation`) {
        super(id);
    }
}
